// src/components/Blocks/Banner/Edit.jsx
import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import BannerView from './View';
import schema from './schema';
import CustomBlockDataForm from './CustomBlockDataForm';

const BannerEdit = (props) => {
  const { data, onChangeBlock, block, selected, blocksConfig } = props;
  const bannerSchema = schema(props);

  // Normalizza i dati con valori di default
  const normalizedData = {
    ...data,
    image: data.image ?? bannerSchema.properties.image.default,
    titleText: data.titleText ?? bannerSchema.properties.titleText.default,
    text: data.text ?? bannerSchema.properties.text.default,
    buttonText: data.buttonText ?? bannerSchema.properties.buttonText.default,
    buttonLink: data.buttonLink ?? bannerSchema.properties.buttonLink.default,
    styleTextInEvidence: data.styleTextInEvidence ?? bannerSchema.properties.styleTextInEvidence.default,
  };

  return (
    <>
      <BannerView {...props} data={normalizedData} />
      <SidebarPortal selected={selected}>
        <CustomBlockDataForm
          schema={bannerSchema}
          title={bannerSchema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock} // Passiamo onChangeBlock
          formData={normalizedData}
          block={block}
          blocksConfig={blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(BannerEdit);